export default __webpack_public_path__ + "static/media/logo-rtl-dark.04df1738.svg";